import classNames from "classnames";
import { forwardRef } from "react";
import {
  FormGroup,
  FormGroupProps,
  TextArea as TextAreaComponent,
  TextAreaProps as TextAreaComponentProps,
} from "@blueprintjs/core";

export interface TextAreaProps
  extends Omit<FormGroupProps, "children" | "onChange">,
    Omit<TextAreaComponentProps, "disabled" | "className" | "ref"> {
  inputGroupClassName?: string;
}

export const TextArea = forwardRef<HTMLTextAreaElement, TextAreaProps>(
  (
    {
      className,
      contentClassName,
      inputGroupClassName,
      helperText,
      inline,
      intent,
      label,
      labelFor,
      labelInfo,
      style,
      subLabel,
      ...props
    },
    ref
  ) => {
    return (
      <FormGroup
        className={classNames("!mb-0", className)}
        {...{
          contentClassName,
          helperText,
          inline,
          intent,
          label,
          labelFor,
          labelInfo,
          style,
          subLabel,
        }}
      >
        <TextAreaComponent
          className={inputGroupClassName}
          small
          {...props}
          inputRef={ref}
        />
      </FormGroup>
    );
  }
);

TextArea.displayName = "TextArea";
